package components

import androidx.compose.runtime.Composable
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.ElementBuilder
import org.jetbrains.compose.web.dom.TagElement
import org.w3c.dom.Element
import org.w3c.dom.HTMLDListElement
import org.w3c.dom.HTMLElement

class ElementBuilderImplementation<TElement : Element>(private val tagName: String) : ElementBuilder<TElement> {
    private val el: Element by lazy { document.createElement(tagName) }
    override fun create(): TElement = el.cloneNode() as TElement
}

val Dl: ElementBuilder<HTMLDListElement> = ElementBuilderImplementation("dl")
val Dt: ElementBuilder<HTMLDListElement> = ElementBuilderImplementation("dt")
val Dd: ElementBuilder<HTMLDListElement> = ElementBuilderImplementation("dd")

@Composable
fun Dl(
    attrs: AttrBuilderContext<HTMLDListElement>? = null,
    content: ContentBuilder<HTMLElement>? = null
) {
    TagElement(
        elementBuilder = Dl,
        applyAttrs = attrs,
        content = content
    )
}

@Composable
fun Dt(
    attrs: AttrBuilderContext<HTMLDListElement>? = null,
    content: ContentBuilder<HTMLElement>? = null
) {
    TagElement(
        elementBuilder = Dt,
        applyAttrs = attrs,
        content = content
    )
}

@Composable
fun Dd(
    attrs: AttrBuilderContext<HTMLDListElement>? = null,
    content: ContentBuilder<HTMLElement>? = null
) {
    TagElement(
        elementBuilder = Dd,
        applyAttrs = attrs,
        content = content
    )
}